<template>
  <span>
    <div align="center" class="pt-6 subtitle-2">
      {{ $t("intervals") }}
    </div>
    <div v-if="experiment" align="center">
      <v-chip
        v-for="interval in experiment.intervals"
        :key="interval"
        class="ma-2"
        small
      >
        {{ interval }}
      </v-chip>
    </div>

    <Plotly
      :data="graphData"
      :layout="graphLayout"
      :display-mode-bar="false"
      class="mx-12"
      ref="plotly"
    ></Plotly>

    <vue-slide-bar
      v-model="sliderGraph"
      :data="sliderData"
      class="mx-12 px-12"
    />
    <!-- <div class="text-center mb-2">
      SYS:
      <span class="subtitle-2">{{ Math.abs(Math.log10(sliderGraph)) }}</span>
    </div> -->

    <v-row class="pt-0 mb-10" align="center" justify="center">
      <v-col v-if="experiment.resultsImage" cols="12" sm="4" class="pt-0">
        <vue-slide-bar v-model="sliderOpacity" />
        <div class="text-center subtitle-2">{{ $t("opacity") }}</div>
      </v-col>
    </v-row>
  </span>
</template>

<script>
import { Plotly } from "vue-plotly";
import VueSlideBar from "vue-slide-bar";

export default {
  name: "Experiment",
  props: {
    experimentId: String,
  },
  components: {
    Plotly,
    VueSlideBar,
  },
  data: () => ({
    sliderGraph: null,
    sliderOpacity: 50,
  }),
  mounted() {
    this.sliderGraph = this.graphMax;
  },
  computed: {
    experiment() {
      return this.$store.state.account.current.experiments.find(
        (experiment) => experiment.id === this.experimentId
      );
    },
    sliderData() {
      if (this.experiment)
        return this.experiment.data.z.flat().sort((a, b) => b - a);
    },
    graphMin() {
      if (this.experiment) return Math.min(...this.experiment.data.z.flat());
    },
    graphMax() {
      if (this.experiment) return Math.max(...this.experiment.data.z.flat());
    },
    graphData() {
      if (this.experiment)
        return [
          {
            x: this.experiment.data.x,
            y: this.experiment.data.y,
            z: this.experiment.data.z.map((interval) =>
              interval.map((v) => (v <= this.sliderGraph ? v : null))
            ),
            type: "contour",
            zsmooth: "best",
            connectgaps: true,
            autocontour: true,
            showscale: true,
            colorbar: { exponentformat: "e" },
            line: { smoothing: 1.3 },
          },
        ];
    },
    graphLayout() {
      return {
        autosize: true,
        margin: { l: 50, r: 50, t: 10, b: 30 },
        xaxis: {
          scaleanchor: "y",
          scaleratio: 1,
          constrain: "domain",
        },
        yaxis: {
          scaleanchor: "x",
          constrain: "domain",
        },
        images: [
          {
            source: this.experiment.resultsImage,
            xref: "x",
            yref: "y",
            x: 1,
            y: this.experiment.data.y.length,
            sizex: this.experiment.data.x.length,
            sizey: this.experiment.data.y.length - 1,
            xanchor: "left",
            yanchor: "top",
            sizing: "stretch",
            opacity: this.sliderOpacity / 100,
          },
        ],
      };
    },
  },
};
</script>
